import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {FileManagementService} from '@core/services/file-management.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {Router} from '@angular/router';
import {Api} from '@shared/constants/common-field.constants';
import {take} from 'rxjs/operators';
import {DialogService} from "@shared/services/dialog-service";
import {Dynamic_Grid_Data_Request_Parameters} from '@shared/store/actions/virtual-grid.actions';
import {ParticleCacheService} from '@core/services/particle-cache.service';

@Injectable({
  providedIn: 'root'
})
export class ScenarioCountryCalculatorHandler implements IPlatformToolHandler {
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter();
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  private sourceType: string;

  constructor(private commandService: CommandService,
              private router: Router,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService,
              private fileManagementService: FileManagementService,
              private dialogService: DialogService,
              private particleCacheService: ParticleCacheService
              ) { }


  destroy(): void {
  }

  executeCommand(command: PlatformCommand, callBack?: any) {
    command.projectId = '[PROJECT_ID]';
    this.executeCommandToApi(command);
    
  }

  setSelectedTab(selectedTab: TabModel): void {
  }

  valueChanged($event) {
    if($event.fieldDefinition?.key === 'EntityCode') {
      const openCalculatorCommand = this.magicLinkModel.additionalCommands['OpenCalculatorCommand'];
      if (openCalculatorCommand) {
        openCalculatorCommand.fieldValues['ReportingEntityCode'] = $event.item.cells.ReportingEntity.value;
        openCalculatorCommand.fieldValues['EntityName'] = $event.item.cells.EntityName.value;
        this.executeCommand(openCalculatorCommand);
      };
    }
    else if($event.action.id === "Edit"){
      let command = this.magicLinkModel.additionalCommands['UpdateCountryCalculatorCommand'];
      if (command) {
        const value = $event.item.cells[$event.fieldDefinition.key].value;
        command.fieldValues['FieldKey']= $event.fieldDefinition.key
        command.fieldValues['CountryCode'] = $event.item.cells.Country?.value;
        command.fieldValues['FieldValue'] = value;
        this.executeCommand(command);
      }
      command = this.magicLinkModel.additionalCommands['UpdateFxRateCommand'];
      if (command) {
        const value = $event.item.cells[$event.fieldDefinition.key].value;
        command.fieldValues['ScenarioFxRateId'] = $event.item.id;
        command.fieldValues['FieldKey']= $event.fieldDefinition.key
        command.fieldValues['FieldValue'] = value;
        this.executeCommand(command);
      }
    }
    else if ($event.action.id === "Select"){
      const openCountryCalculatorCommand = this.magicLinkModel.additionalCommands['OpenCountryCalculatorCommand'];
      if (openCountryCalculatorCommand) {
        openCountryCalculatorCommand.fieldValues['CountryCode'] = $event.item.cells.Country.value;
        openCountryCalculatorCommand.fieldValues['CalculatorId'] = $event.item.id;
        this.executeCommand(openCountryCalculatorCommand);
      };
    }
    else if($event.action.id === 'Archive' || $event.action.id === 'Unarchive') {
      this.dialogService.showYesNoDialog(`Confirm ${$event.action.text}`, `Are you sure you want to ${$event.action.text.toString().toLowerCase()} this calculator?`).pipe().subscribe(state => {
        if (state && state.action === 'OK') {
          const command = this.magicLinkModel.additionalCommands['ArchiveScenarioCountryCalculatorCommand'];
          command.fieldValues['IsArchived'] = $event.action.id === 'Archive';
          if (command) {
            command.fieldValues['CountryCode'] = $event.item.cells.Country?.value;
            command.fieldValues['ReportingEntityCode'] = $event.item.cells.EntityCode?.value;
            this.executeCommand(command);
          }
        }
        else{
          return;
        }
      });


    }
    else if($event.action.id === "UpdateStatus"){
      const command = this.magicLinkModel.additionalCommands['UpdateScenarioCalculatorStatusCommand'];
      if (command) {
        command.fieldValues['CalculatorId'] = $event.item.id;
        this.executeCommand(command);
      }
    }
    else if($event.action.id === 'UpdateShareStatus') {
        const command = this.magicLinkModel.additionalCommands['ChangeCountryCalculatorShareStatusCommand'];
        if(command) {
          command.fieldValues['ScenarioCalculationId'] = $event.item.id;
          command.fieldValues['CurrentStatus'] = $event.item.cells.ShareStatus?.value;
          command.fieldValues['PlatformLinkId'] = this.magicLinkModel.id;
          this.executeCommand(command);
        }
    }
    else if ($event.command) {
      switch ($event.command.name) {
        default:
          this.executeCommand($event.command);
          return true;
      }
    }
  }

  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('[scenario-platform-command] Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommandToApi(commandResponse.fieldValues['RedirectCommand']);
            return;
          }
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          }
          if (commandResponse.fieldValues['SnackBarMessage']) {
            const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
          }
          if (commandResponse.fieldValues['ErrorMessage']) {
            this.snackBarService.showError(commandResponse.fieldValues['ErrorMessage']);
          }

          if (commandResponse.fieldValues['FileId']) {
            const fileId = commandResponse.fieldValues['FileId'];
            const fileName = commandResponse.fieldValues['FileName'];

            this.downloadFile(fileId, fileName);
          }
          if (commandResponse.fieldValues['PlatformLinkModel']) {
            this.magicLinkModel = commandResponse.fieldValues['PlatformLinkModel'];
            this.magicLinkModelValueChangedHandler({
              id: 'PlatformToolContainerComponent', value: commandResponse.fieldValues['PlatformLinkModel'],
              magicLinkModel: this.magicLinkModel
            });
            return;
          }
          if (commandResponse.fieldValues['Refresh']) {
            this.invalidateSubject.invalidate('Refresh');
            return;
          }

          this.invalidateSubject.invalidate();
        },
        error => {
          console.log(error);
          this.fuseSplashScreenService.hide();
        });
    }
  }

  private downloadFile(fileId: string, fileName: string) {
    this.fileManagementService.downloadClientFileWithId(fileId).subscribe(payload => {
      this.fileManagementService.openSaveFileWindow(payload, fileName);
      this.fuseSplashScreenService.hide();
    });
  }

  private magicLinkModelValueChangedHandler(command: any) {
    this.magicLinkModelValueChanged.emit(command);
  }


  private handleToggleGridFilterByArchiveCommand(command: PlatformCommand) {
    const updateViewCommand = new PlatformCommand('CreateCountryCalculatorToolLinkCommand', Api.Spreadsheet);
    updateViewCommand.fieldValues['ShowArchived'] = command.isChecked;
    updateViewCommand.fieldValues['ScenarioId'] = command.fieldValues['ScenarioId'];
    updateViewCommand.fieldValues['ScenarioType'] = command.fieldValues['ScenarioType'];
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(updateViewCommand).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
        if (response.fieldValues['PlatformLinkModel']) {
          this.magicLinkModel = response.fieldValues['PlatformLinkModel'];
          this.sourceType = this.magicLinkModel.tabBar.tabs[0].tabData['SourceType'];
          const params = this.particleCacheService.getUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, this.sourceType);
          params['ShowArchived'] =  command.isChecked;
          this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, this.sourceType, params);
          this.invalidateSubject.invalidate('');
        } else {
          console.log('Platform link model not found');
        }
        this.fuseSplashScreenService.hide();
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('Operation failed!!!', error);
      });
  }
}
